import { render, staticRenderFns } from "./col1_1.vue?vue&type=template&id=47a5170e&scoped=true"
import script from "./col1_1.vue?vue&type=script&lang=js"
export * from "./col1_1.vue?vue&type=script&lang=js"
import style0 from "./col1_1.vue?vue&type=style&index=0&id=47a5170e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5170e",
  null
  
)

export default component.exports